// src/firebase/firebase-init.js - VERSION CORRIGÉE
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// 🚀 AJOUT : Importation de axios
import axios from "axios";

// Votre configuration Firebase
const firebaseConfig = {
  apiKey: "AIzaSyAnsfhC4qSlnbrOFvw-V_V0Iulg5nRRkFg",
  authDomain: "blackroq-4112a.firebaseapp.com",
  projectId: "blackroq-4112a",
  storageBucket: "blackroq-4112a.firebasestorage.app",
  messagingSenderId: "546535069813",
  appId: "1:546535069813:web:71e1e544369a07a22a003c",
  measurementId: "G-E4G71XRBFK"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestForToken = async () => {
  try {
    // 🚀 AJOUT : Vérification support navigateur
    if (!('Notification' in window)) {
      console.log('❌ Notifications non supportées par ce navigateur');
      return null;
    }

    // Vérifier si la permission est déjà accordée
    if (Notification.permission === 'granted') {
      console.log('✅ Permission notifications déjà accordée');
    } else if (Notification.permission === 'denied') {
      console.log('❌ Permission notifications refusée précédemment');
      return null;
    }

    // Demander la permission si nécessaire
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      console.log('✅ Permission notifications accordée');
      
      try {
        const token = await getToken(messaging, { 
          vapidKey: "BHpG9MlNUfFQjrVlGtCUDDHHcK0jLLtp4wHfqUoILkKRMYXXIXAyzqxn0ggR8DL8fqycKZMUIoO5HQq_Xw_XP5M" 
        });
        
        if (token) {
          console.log('📱 Token FCM généré:', token.substring(0, 20) + '...');
          
          // 🚀 AJOUT : Stockage temporaire local
          localStorage.setItem('fcm_token', token);
          localStorage.setItem('fcm_token_timestamp', Date.now().toString());
          
          return token;
        } else {
          console.log('⚠️ Aucun token disponible - L\'utilisateur doit autoriser les notifications');
          return null;
        }
      } catch (tokenError) {
        console.error('❌ Erreur génération token:', tokenError);
        return null;
      }
    } else {
      console.log('❌ Permission notifications refusée par l\'utilisateur');
      return null;
    }
  } catch (err) {
    console.error('❌ Erreur lors de la récupération du jeton:', err);
    return null;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('📨 Message Firebase reçu en foreground:', payload);
      resolve(payload);
    });
  });

// 🚀 AJOUT : Fonction pour envoyer le token au backend
export const sendTokenToBackend = async (token) => {
  try {
    const jwtToken = localStorage.getItem('token');
    
    if (!jwtToken) {
      console.log('⚠️ Utilisateur non connecté, token FCM non envoyé');
      return false;
    }

    const config = { 
      headers: { 
        'x-auth-token': jwtToken,
        'Content-Type': 'application/json'
      } 
    };

    const response = await axios.post(
      'https://api.blackroq.pro/api/notifications/save-token', 
      { fcmToken: token }, 
      config
    );

    if (response.data.success) {
      console.log('✅ Token FCM enregistré sur le serveur');
      return true;
    } else {
      console.log('⚠️ Erreur enregistrement token:', response.data.msg);
      return false;
    }
  } catch (error) {
    console.error('❌ Erreur envoi token au backend:', error.message);
    return false;
  }
};

// 🚀 AJOUT : Vérifier si le token a déjà été enregistré aujourd'hui
export const shouldRegisterToken = () => {
  const lastRegistration = localStorage.getItem('fcm_token_timestamp');
  if (!lastRegistration) return true;
  
  const now = Date.now();
  const lastRegTime = parseInt(lastRegistration, 10);
  const hoursSinceLastReg = (now - lastRegTime) / (1000 * 60 * 60);
  
  // Ré-enregistrer toutes les 24h max
  return hoursSinceLastReg > 24;
};

export { messaging };